import React, { useState, useEffect } from 'react'
import { Row, Col, Image, Form, Button, Spinner } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import Card from '../../../components/Card'
import axios from 'axios'
import auth2 from '../../../assets/images/auth/02.png'
import { RANDOM_CAPTCHA_VALUE, BACKEND_API_BASE_URL } from '../../../utilities/constant'
import { API_USER_PASSWORD_RESET_MAIL, API_VERIFY_OTP, API_RESET_PASSWORD } from '../../../service/url'
import { postApiNoAuthCall } from '../../../service/postApiCall'
import { Password } from 'primereact/password'




const Recoverpw = () => {

   const [username, setUsername] = useState('')
   const [captcha, setCaptcha] = useState('')
   const [captchaValue, setCaptchaValue] = useState('')
   const [isCaptchaError, setIsCaptchaError] = useState(false)
   const [captchaError, setCaptchaError] = useState('')
   const [isLoading, setIsLoading] = useState(false)
   const [isResendingOTP, setIsResendingOTP] = useState(false)
   const [showResetForm, setShowResetForm] = useState(false)
   const [maskedEmail, setMaskedEmail] = useState('')
   const [otp, setOtp] = useState('')
   const [newPassword, setNewPassword] = useState('')
   const [confirmPassword, setConfirmPassword] = useState('')
   const [isValidatingOTP, setIsValidatingOTP] = useState(false)
   const [isOTPValid, setIsOTPValid] = useState(null)
   const [otpValidationMessage, setOtpValidationMessage] = useState('')


   const generateCaptcha = () => {
      const chars = RANDOM_CAPTCHA_VALUE
      let result = ''
      for (let i = 0; i < 6; i++) {
         result += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      setCaptchaValue(result)
   }

   useEffect(() => {
      generateCaptcha()
   }, [])

   // Validate OTP when it reaches 6 digits
   useEffect(() => {
      if (otp.length === 6) {
         validateOTP(otp)
      } else if (otp.length < 6 && otp.length > 0) {
         setIsValidatingOTP(true)
         setIsOTPValid(false) 
         setOtpValidationMessage('Wrong OTP')
      } else if (otp.length === 0) {
         setIsOTPValid(null)
         setOtpValidationMessage('')
         setIsValidatingOTP(false)
      }
   }, [otp])

   const validateOTP = async (otpValue) => {
      setIsValidatingOTP(true)
      setOtpValidationMessage('')
      
      try {
         const response = await postApiNoAuthCall(API_VERIFY_OTP, { 
            username: username, 
            otp: otpValue 
         })
         
         if (response && response.success) {
            setIsOTPValid(true)
            setOtpValidationMessage('OTP validated')
            setIsValidatingOTP(false)
         } else {
            setIsOTPValid(false)
            setOtpValidationMessage('Wrong OTP')
            setIsValidatingOTP(false)
         }
      } catch (error) {
         setIsOTPValid(false)
         setOtpValidationMessage('Wrong OTP')
         setIsValidatingOTP(false)
      }
   }

   const handleRefreshCaptcha = () => {
      generateCaptcha()
      setCaptcha('')
   }

   const handleSubmit = (e) => {
      e.preventDefault()
      setIsCaptchaError(false);

      if (captcha !== captchaValue) {
         setIsCaptchaError(true);
         setCaptchaError('Captcha does not match')
         return
      }

      if (!username.trim()) {
         setIsCaptchaError(true);
         setCaptchaError('Username is required')
         return
      }

      setIsLoading(true)

      postApiNoAuthCall(API_USER_PASSWORD_RESET_MAIL, {username})
         .then((resp) => {
            if (resp && resp.success) {
               setMaskedEmail(resp.data?.email || '')
               setShowResetForm(true)
            }
         })
         .catch((error) => {
            console.error("Error:", error);
            setIsCaptchaError(true);
            setCaptchaError(typeof error === 'string' ? error : 'Something went wrong. Please try again.')
         })
         .finally(() => {
            setIsLoading(false)
         })
   }

   const handleResetPassword = async (e) => {
      e.preventDefault()
      
      // Validate OTP is verified
      if (!isOTPValid) {
         setOtpValidationMessage('Please verify OTP first')
         return
      }

      // Validate passwords match
      if (newPassword !== confirmPassword) {
         toast.error('Password and confirm password do not match')
         return
      }

      // Validate password is not empty
      if (!newPassword.trim() || newPassword.length < 6) {
         toast.error('Password must be at least 6 characters long')
         return
      }

      setIsLoading(true)

      try {
         const response = await postApiNoAuthCall(API_RESET_PASSWORD, {
            username: username,
            otp: otp,
            newPassword: newPassword,
            confirmPassword: confirmPassword
         })

         if (response && response.success) {
            toast.success('Password reset successfully! Redirecting to login...')
            // Redirect to login page
            setTimeout(() => {
               window.location.href = '/auth/sign-in'
            }, 1500)
         }
      } catch (error) {
         console.error("Error resetting password:", error);
         toast.error(typeof error === 'string' ? error : 'Failed to reset password. Please try again.')
      } finally {
         setIsLoading(false)
      }
   }

   const handleResendOTP = async () => {
      if (!username.trim()) {
         toast.error('Username is required')
         return
      }

      setIsResendingOTP(true)

      try {
         const response = await postApiNoAuthCall(API_USER_PASSWORD_RESET_MAIL, { username })

         if (response && response.success) {
            // Reset OTP input and validation state
            setOtp('')
            setIsOTPValid(null)
            setOtpValidationMessage('')
            setIsValidatingOTP(false)
            
            // Update masked email if provided
            if (response.data?.email) {
               setMaskedEmail(response.data.email)
            }
            
            toast.success('New OTP has been sent to your email')
         }
      } catch (error) {
         console.error("Error resending OTP:", error);
         toast.error(typeof error === 'string' ? error : 'Failed to resend OTP. Please try again.')
      } finally {
         setIsResendingOTP(false)
      }
   }

   return (
      <>
         <section className="login-content">
            <Row className="m-0 align-items-center bg-white vh-100">
               <Col md="6" className="d-md-block d-none bg-primary p-0 mt-n1 vh-100 overflow-hidden">
                  <Image src={auth2} className="img-fluid gradient-main animated-scaleX" alt="images" />
               </Col>
               <Col md="6" className="p-0" style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  background: '#f8fafc',
                  padding: '2rem'
               }}>
               <div style={{
                  width: '100%',
                  maxWidth: '420px',
                  backdropFilter: 'blur(20px)',
                  background: 'rgba(255, 255, 255, 0.95)',
                  borderRadius: '20px',
                  padding: '2.5rem',
                  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                  animation: 'fadeIn 0.8s ease'
               }}>
                  <div style={{ textAlign: 'left', width: '100%' }}>
                           {!showResetForm ? (
                              <>
                                 <h2 style={{ 
                                    fontSize: '1.75rem', 
                                    fontWeight: '500', 
                                    color: '#0f172a', 
                                    marginBottom: '0.5rem',
                                    fontFamily: '"Inter", sans-serif'
                                 }}>
                                    Forgot Password
                                 </h2>
                                 
                                 <Form onSubmit={handleSubmit}>
                              <Form.Group style={{ marginBottom: '1.5rem', marginTop:'1.5rem' }}>
                                 <Form.Label style={{
                                    display: 'block',
                                    marginTop:'1.5rem',
                                    marginBottom: '0.5rem',
                                    fontWeight: '400',
                                    color: '#334155',
                                    fontSize: '0.875rem'
                                 }}>
                                    Username
                                 </Form.Label>
                                 <Form.Control
                                    type="text"
                                    placeholder="Enter your username"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    style={{
                                       width: '100%',
                                       padding: '0.75rem 1rem',
                                       borderRadius: '12px',
                                       border: '1px solid #cbd5e1',
                                       background: '#ffffff',
                                       fontSize: '1rem',
                                       outline: 'none',
                                       transition: 'border-color 0.3s, box-shadow 0.3s'
                                    }}
                                    onFocus={(e) => {
                                       e.target.style.borderColor = '#0c37a3ff'
                                       e.target.style.boxShadow = '0 0 0 3px rgba(12, 70, 163, 0.2)'
                                    }}
                                    onBlur={(e) => {
                                       e.target.style.borderColor = '#cbd5e1'
                                       e.target.style.boxShadow = 'none'
                                    }}
                                 />
                              </Form.Group>

                              <Form.Group style={{ marginBottom: '1.5rem' }}>
                                 <Form.Label style={{
                                    display: 'block',
                                    marginBottom: '0.5rem',
                                    fontWeight: '400',
                                    color: '#334155',
                                    fontSize: '0.875rem'
                                 }}>
                                    Captcha
                                 </Form.Label>
                                 <Form.Control
                                    type="text"
                                    placeholder="Enter CAPTCHA"
                                    value={captcha}
                                    onChange={(e) => setCaptcha(e.target.value)}
                                    style={{
                                       width: '100%',
                                       padding: '0.75rem 1rem',
                                       borderRadius: '12px',
                                       border: '1px solid #cbd5e1',
                                       background: '#ffffff',
                                       fontSize: '1rem',
                                       outline: 'none',
                                       transition: 'border-color 0.3s, box-shadow 0.3s'
                                    }}
                                    onFocus={(e) => {
                                       e.target.style.borderColor = '#0c37a3ff'
                                       e.target.style.boxShadow = '0 0 0 3px rgba(12, 70, 163, 0.2)'
                                    }}
                                    onBlur={(e) => {
                                       e.target.style.borderColor = '#cbd5e1'
                                       e.target.style.boxShadow = 'none'
                                    }}
                                 />
                              </Form.Group>

                              <div style={{ 
                                 display: 'flex', 
                                 alignItems: 'center', 
                                 justifyContent: 'center',
                                 marginBottom: '1.5rem',
                                 gap: '12px',
                                 padding: '0.75rem 1rem',
                                 borderRadius: '12px',
                                 background: '#f1f5f9',
                                 border: '1px solid #e2e8f0'
                              }}>
                                 <span style={{
                                    fontSize: '1.25rem',
                                    fontStyle: 'italic',
                                    color: '#0f172a',
                                    fontFamily: '"Inter", sans-serif',
                                    letterSpacing: '3px',
                                    fontWeight: '600'
                                 }}>
                                    {captchaValue}
                                 </span>
                                 <button
                                    type="button"
                                    onClick={handleRefreshCaptcha}
                                    style={{
                                       background: 'none',
                                       border: 'none',
                                       cursor: 'pointer',
                                       padding: '6px',
                                       display: 'flex',
                                       alignItems: 'center',
                                       color: '#475569',
                                       borderRadius: '8px',
                                       transition: 'background 0.2s'
                                    }}
                                    onMouseEnter={(e) => e.target.style.background = '#e2e8f0'}
                                    onMouseLeave={(e) => e.target.style.background = 'none'}
                                 >
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                       <path d="M4 4V9H4.58152M19.9381 11C19.446 7.05369 16.0796 4 12 4C8.64262 4 5.76829 6.06817 4.58152 9M4.58152 9H9M20 20V15H19.4185M19.4185 15C18.2317 17.9318 15.3574 20 12 20C7.92038 20 4.55399 16.9463 4.06189 13M19.4185 15H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                           </svg>
                                 </button>
                              </div>
                              {isCaptchaError && (
                                 <div style={{ 
                                    textAlign: "center", 
                                    marginBottom: "1rem",
                                    marginTop: "-0.5rem"
                                 }}>
                                    <span style={{ 
                                       color: "#dc3545", 
                                       fontSize: '0.875rem',
                                       fontWeight: '500'
                                    }}>
                                       {captchaError}
                                    </span>
                                 </div>
                              )}

                                    <Button 
                                       type="submit" 
                                       variant="primary" 
                                       disabled={isLoading}
                                       style={{
                                          width: '100%',
                                          borderRadius: '12px',
                                          padding: '1rem',
                                          fontSize: '1rem',
                                          fontWeight: '600',
                                          backgroundColor: isLoading ? '#cbd5e1' : '#4361ee',
                                          border: 'none',
                                          marginBottom: '1rem',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          gap: '8px',
                                          cursor: isLoading ? 'not-allowed' : 'pointer',
                                          transition: 'background 0.3s, transform 0.1s',
                                          outline: 'none'
                                       }}
                                       onMouseEnter={(e) => {
                                          if (!isLoading) {
                                             e.target.style.backgroundColor = '#0c3ca3ff'
                                          }
                                       }}
                                       onMouseLeave={(e) => {
                                          if (!isLoading) {
                                             e.target.style.backgroundColor = '#4361ee'
                                          }
                                       }}
                                       onMouseDown={(e) => {
                                          if (!isLoading) {
                                             e.target.style.transform = 'scale(0.98)'
                                             e.target.style.backgroundColor = '#0c28a3ff'
                                          }
                                       }}
                                       onMouseUp={(e) => {
                                          if (!isLoading) {
                                             e.target.style.transform = 'scale(1)'
                                          }
                                       }}
                                    >
                                       {isLoading && (
                                          <Spinner
                                             as="span"
                                             animation="border"
                                             size="sm"
                                             role="status"
                                             aria-hidden="true"
                                             style={{
                                                width: '20px',
                                                height: '20px',
                                                borderWidth: '2px'
                                             }}
                                          />
                                       )}
                                       {isLoading ? 'Requesting OTP...' : 'Request OTP'}
                                    </Button>
                                 </Form>

                                 <Link 
                                    to="/auth/sign-in" 
                                    style={{
                                       color: '#0122c7',
                                       textDecoration: 'none',
                                       fontSize: '0.875rem',
                                       display: 'block',
                                       textAlign: 'center',
                                       fontWeight: '500',
                                       transition: 'color 0.2s'
                                    }}
                                    onMouseEnter={(e) => e.target.style.color = '#0e125a'}
                                    onMouseLeave={(e) => e.target.style.color = '#0122c7'}
                                 >
                                    Back To Login
                        </Link>
                              </>
                           ) : (
                              <>
                                 <h2 style={{ 
                                    fontSize: '1.75rem', 
                                    fontWeight: '700', 
                                    color: '#0f172a', 
                                    marginBottom: '0.5rem',
                                    fontFamily: '"Inter", sans-serif'
                                 }}>
                                    Reset Your Password
                                 </h2>

                                 {maskedEmail && (
                                    <p style={{
                                       fontSize: '0.875rem',
                                       color: '#64748b',
                                       marginBottom: '1.5rem',
                                       fontWeight: '500'
                                    }}>
                                       OTP sent to {maskedEmail}
                                    </p>
                                 )}

                                 <Form onSubmit={handleResetPassword}>
                                    <Form.Group style={{ marginBottom: '1.5rem' }}>
                                       <div style={{ position: 'relative' }}>
                                          <Form.Control
                                             type="text"
                                             placeholder="Enter OTP..."
                                             value={otp}
                                             onChange={(e) => {
                                                const value = e.target.value.replace(/\D/g, '').slice(0, 6) // Only numbers, max 6 digits
                                                setOtp(value)
                                             }}
                                             maxLength={6}
                                             style={{
                                                width: '100%',
                                                padding: '0.75rem 1rem',
                                                paddingRight: '50px',
                                                borderRadius: '12px',
                                                border: `1px solid ${isOTPValid === true ? '#28a745' : isOTPValid === false ? '#dc3545' : '#cbd5e1'}`,
                                                background: '#ffffff',
                                                fontSize: '1rem',
                                                outline: 'none',
                                                transition: 'border-color 0.3s, box-shadow 0.3s'
                                             }}
                                             onFocus={(e) => {
                                                if (isOTPValid !== true && isOTPValid !== false) {
                                                   e.target.style.borderColor = '#0c37a3ff'
                                                   e.target.style.boxShadow = '0 0 0 3px rgba(12, 70, 163, 0.2)'
                                                }
                                             }}
                                             onBlur={(e) => {
                                                if (isOTPValid !== true && isOTPValid !== false) {
                                                   e.target.style.borderColor = '#cbd5e1'
                                                   e.target.style.boxShadow = 'none'
                                                }
                                             }}
                                          />
                                          {otp.length > 0 && isOTPValid !== true && (
                                             <div style={{
                                                position: 'absolute',
                                                right: '15px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                display: 'flex',
                                                alignItems: 'center'
                                             }}>
                                                <Spinner
                                                   animation="border"
                                                   size="sm"
                                                   style={{
                                                      color: '#dc3545', // Always red when spinner is showing
                                                      width: '20px',
                                                      height: '20px',
                                                      borderWidth: '2px'
                                                   }}
                                                />
                                             </div>
                                          )}
                                       </div>
                                       {otp.length > 0 && (
                                          <div style={{
                                             
                                             marginTop: '8px',
                                             fontSize: '14px',
                                             color: isOTPValid === true ? '#28a745' : '#dc3545',
                                             textAlign: 'right',
                                             fontWeight: '500'
                                          }}>
                                             {otpValidationMessage || 'Wrong OTP'}
                                          </div>
                                       )}
                                    </Form.Group>

                                    <Form.Group style={{ marginBottom: '1.5rem' }}>
                                       <Form.Label style={{
                                          display: 'block',
                                          marginBottom: '0.5rem',
                                          fontWeight: '500',
                                          color: '#334155',
                                          fontSize: '0.875rem'
                                       }}>
                                          New Password
                                       </Form.Label>
                                       <Form.Control
                                          type="password"
                                          placeholder="Enter your new password"
                                          value={newPassword}
                                          onChange={(e) => setNewPassword(e.target.value)}
                                          style={{
                                             width: '100%',
                                             padding: '0.75rem 1rem',
                                             borderRadius: '12px',
                                             border: '1px solid #cbd5e1',
                                             background: '#ffffff',
                                             fontSize: '1rem',
                                             outline: 'none',
                                             transition: 'border-color 0.3s, box-shadow 0.3s'
                                          }}
                                          onFocus={(e) => {
                                             e.target.style.borderColor = '#0c37a3ff'
                                             e.target.style.boxShadow = '0 0 0 3px rgba(12, 70, 163, 0.2)'
                                          }}
                                          onBlur={(e) => {
                                             e.target.style.borderColor = '#cbd5e1'
                                             e.target.style.boxShadow = 'none'
                                          }}
                                       />
                                    </Form.Group>

                                    <Form.Group style={{ marginBottom: '1.5rem' }}>
                                       <Form.Label style={{
                                          display: 'block',
                                          marginBottom: '0.5rem',
                                          fontWeight: '500',
                                          color: '#334155',
                                          fontSize: '0.875rem'
                                       }}>
                                          Confirm Password
                                       </Form.Label>
                                       
                                       <Form.Control
                                          type="password"
                                          placeholder="Confirm your new password"
                                          value={confirmPassword}
                                          onChange={(e) => setConfirmPassword(e.target.value)}
                                          style={{
                                             width: '100%',
                                             padding: '0.75rem 1rem',
                                             borderRadius: '12px',
                                             border: '1px solid #cbd5e1',
                                             background: '#ffffff',
                                             fontSize: '1rem',
                                             outline: 'none',
                                             transition: 'border-color 0.3s, box-shadow 0.3s'
                                          }}
                                          onFocus={(e) => {
                                             e.target.style.borderColor = '#0c37a3ff'
                                             e.target.style.boxShadow = '0 0 0 3px rgba(12, 70, 163, 0.2)'
                                          }}
                                          onBlur={(e) => {
                                             e.target.style.borderColor = '#cbd5e1'
                                             e.target.style.boxShadow = 'none'
                                          }}
                                       />
                                 </Form.Group>

                                    <Button 
                                       type="submit" 
                                       variant="primary" 
                                       disabled={isLoading || !isOTPValid || isResendingOTP}
                                       style={{
                                          width: '100%',
                                          borderRadius: '12px',
                                          padding: '1rem',
                                          fontSize: '1rem',
                                          fontWeight: '600',
                                          backgroundColor: (isLoading || !isOTPValid || isResendingOTP) ? '#cbd5e1' : '#4361ee',
                                          border: 'none',
                                          marginBottom: '1rem',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          gap: '8px',
                                          cursor: (isLoading || !isOTPValid || isResendingOTP) ? 'not-allowed' : 'pointer',
                                          transition: 'background 0.3s, transform 0.1s',
                                          outline: 'none'
                                       }}
                                       onMouseEnter={(e) => {
                                          if (!isLoading && !isResendingOTP && isOTPValid) {
                                             e.target.style.backgroundColor = '#0c3ca3ff'
                                          }
                                       }}
                                       onMouseLeave={(e) => {
                                          if (!isLoading && !isResendingOTP && isOTPValid) {
                                             e.target.style.backgroundColor = '#4361ee'
                                          }
                                       }}
                                       onMouseDown={(e) => {
                                          if (!isLoading && !isResendingOTP && isOTPValid) {
                                             e.target.style.transform = 'scale(0.98)'
                                             e.target.style.backgroundColor = '#0c28a3ff'
                                          }
                                       }}
                                       onMouseUp={(e) => {
                                          if (!isLoading && !isResendingOTP && isOTPValid) {
                                             e.target.style.transform = 'scale(1)'
                                          }
                                       }}
                                    >
                                       {isLoading && (
                                          <Spinner
                                             as="span"
                                             animation="border"
                                             size="sm"
                                             role="status"
                                             aria-hidden="true"
                                             style={{
                                                width: '20px',
                                                height: '20px',
                                                borderWidth: '2px'
                                             }}
                                          />
                                       )}
                                       {isLoading ? 'Resetting Password...' : 'Submit'}
                                    </Button>
                        </Form>

                                 <button
                                    type="button"
                                    onClick={handleResendOTP}
                                    disabled={isResendingOTP || isLoading}
                                    style={{
                                       background: 'none',
                                       border: 'none',
                                       color: (isResendingOTP || isLoading) ? '#94a3b8' : '#0122c7',
                                       cursor: (isResendingOTP || isLoading) ? 'not-allowed' : 'pointer',
                                       fontSize: '0.875rem',
                                       fontWeight: '500',
                                       textDecoration: 'none',
                                       transition: 'color 0.2s',
                                       display: 'flex',
                                       alignItems: 'center',
                                       justifyContent: 'center',
                                       gap: '8px',
                                       width: '100%',
                                       textAlign: 'center',
                                       padding: '0.5rem'
                                    }}
                                    onMouseEnter={(e) => {
                                       if (!isResendingOTP && !isLoading) {
                                          e.target.style.color = '#0e125a'
                                       }
                                    }}
                                    onMouseLeave={(e) => {
                                       if (!isResendingOTP && !isLoading) {
                                          e.target.style.color = '#0122c7'
                                       }
                                    }}
                                 >
                                    {isResendingOTP && (
                                       <Spinner
                                          as="span"
                                          animation="border"
                                          size="sm"
                                          role="status"
                                          aria-hidden="true"
                                          style={{
                                             width: '14px',
                                             height: '14px',
                                             borderWidth: '2px'
                                          }}
                                       />
                                    )}
                                    {isResendingOTP ? 'Sending OTP...' : 'Resend OTP'}
                                 </button>
                              </>
                           )}
                        </div>
               </div>
                  <div className="sign-bg sign-bg-right">
                     <svg width="280" height="230" viewBox="0 0 431 398" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g opacity="0.05">
                           <rect x="-157.085" y="193.773" width="543" height="77.5714" rx="38.7857" transform="rotate(-45 -157.085 193.773)" fill="#3B8AFF" />
                           <rect x="7.46875" y="358.327" width="543" height="77.5714" rx="38.7857" transform="rotate(-45 7.46875 358.327)" fill="#3B8AFF" />
                           <rect x="61.9355" y="138.545" width="310.286" height="77.5714" rx="38.7857" transform="rotate(45 61.9355 138.545)" fill="#3B8AFF" />
                           <rect x="62.3154" y="-190.173" width="543" height="77.5714" rx="38.7857" transform="rotate(45 62.3154 -190.173)" fill="#3B8AFF" />
                        </g>
                     </svg>
                  </div>
               </Col>
            </Row>
         </section>
      </>
   )
}

export default Recoverpw
